const SCROLL_LISTENER_OPTIONS = {
  capture: true,
  passive: true,
};

export default {
  data() {
    return {
      floatingPanelStyle: {
        top: '0px',
        left: '0px',
      },
    };
  },

  created() {
    this._floatingPanelPositionHandler = null;
    this._floatingPanelAnimationFrame = null;
  },

  beforeDestroy() {
    this.stopFloatingPanelTracking();
  },

  methods: {
    toggleFloatingPanel() {
      this.isOpen = !this.isOpen;

      if (!this.isOpen) {
        this.stopFloatingPanelTracking();
        return;
      }

      this.$nextTick(() => {
        this.updateFloatingPanelPosition();
        this.startFloatingPanelTracking();
      });
    },

    closeFloatingPanel() {
      this.isOpen = false;
      this.stopFloatingPanelTracking();
    },

    startFloatingPanelTracking() {
      this.stopFloatingPanelTracking();
      this._floatingPanelPositionHandler = () => this.scheduleFloatingPanelPositionUpdate();

      window.addEventListener('resize', this._floatingPanelPositionHandler);
      document.addEventListener(
        'scroll',
        this._floatingPanelPositionHandler,
        SCROLL_LISTENER_OPTIONS
      );
    },

    stopFloatingPanelTracking() {
      if (this._floatingPanelPositionHandler) {
        window.removeEventListener('resize', this._floatingPanelPositionHandler);
        document.removeEventListener(
          'scroll',
          this._floatingPanelPositionHandler,
          SCROLL_LISTENER_OPTIONS
        );
        this._floatingPanelPositionHandler = null;
      }

      if (this._floatingPanelAnimationFrame !== null) {
        window.cancelAnimationFrame(this._floatingPanelAnimationFrame);
        this._floatingPanelAnimationFrame = null;
      }
    },

    scheduleFloatingPanelPositionUpdate() {
      if (this._floatingPanelAnimationFrame !== null) {
        return;
      }

      this._floatingPanelAnimationFrame = window.requestAnimationFrame(() => {
        this._floatingPanelAnimationFrame = null;
        this.updateFloatingPanelPosition();
      });
    },

    updateFloatingPanelPosition() {
      const trigger = this.$refs.trigger;
      const panel = this.$refs.panel;

      if (!this.isOpen || !trigger || !panel) {
        return;
      }

      const options = this.$options.floatingPanel || {};
      const gap = Number(options.gap ?? 7);
      const viewportPadding = Number(options.viewportPadding ?? 8);
      const rightOffset = Number(options.rightOffset ?? 0);
      const triggerRect = trigger.getBoundingClientRect();
      const panelWidth = panel.offsetWidth;

      if (!panelWidth) {
        return;
      }

      const maxLeft = Math.max(
        viewportPadding,
        window.innerWidth - panelWidth - viewportPadding
      );
      const preferredLeft = triggerRect.right + rightOffset - panelWidth;
      const left = Math.min(maxLeft, Math.max(viewportPadding, preferredLeft));

      this.floatingPanelStyle = {
        top: `${triggerRect.bottom + gap}px`,
        left: `${left}px`,
      };
    },
  },
};
